(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["balad-custom-gift-combo"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const formatMoney = (cents, locale, currency) => {
      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency,
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        }).format((Number(cents) || 0) / 100);
      } catch (error) {
        return '\u20B9' + ((Number(cents) || 0) / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
      }
    };

    const showToast = (section, message) => {
      let toast = section.querySelector('[data-gift-toast]');
      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'balad-gift-combo__toast';
        toast.dataset.giftToast = 'true';
        section.appendChild(toast);
      }

      toast.textContent = message;
      toast.classList.add('is-visible');
      window.clearTimeout(toast._hideTimer);
      toast._hideTimer = window.setTimeout(() => {
        toast.classList.remove('is-visible');
      }, 2400);
    };

    const escapeHtml = (value) =>
      String(value ?? '').replace(/[&<>"']/g, (character) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      }[character]));

    const syncHeaderCartCount = (itemCount) => {
      const count = Number(itemCount) || 0;
      const cartTrigger =
        document.querySelector('[data-testid="cart-drawer-trigger"]') ||
        document.querySelector('.balad-header__right a[href*="/cart"]') ||
        document.querySelector('.balad-mobile-tabs a[href*="/cart"]');

      if (!cartTrigger) return;

      const countNode =
        cartTrigger.querySelector('.balad-header__cart-count') ||
        cartTrigger.querySelector('.balad-mobile-tabs__badge');

      if (countNode) countNode.textContent = String(count);
    };

    const openCartDrawer = () => {
      const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
      if (trigger) {
        trigger.click();
        return;
      }

      const cartLink = document.querySelector('.balad-mobile-tabs a[href*="/cart"]');
      if (cartLink) {
        window.location.href = cartLink.href;
      }
    };

    const setupLoopCarousel = (carousel) => {
      if (!(carousel instanceof HTMLElement) || carousel.dataset.loopReady === 'true') return;
      const originals = Array.from(carousel.children).filter(
        (child) => child instanceof HTMLElement && child.hasAttribute('data-gift-card')
      );

      if (originals.length < 3) return;

      carousel.dataset.loopReady = 'true';

      const cloneCards = (cards) =>
        cards.map((card) => {
          const clone = card.cloneNode(true);
          if (clone instanceof HTMLElement) {
            clone.removeAttribute('data-gift-card');
            clone.dataset.giftCardClone = 'true';
            clone.setAttribute('aria-hidden', 'true');
            clone.setAttribute('tabindex', '-1');
            clone.setAttribute('role', 'presentation');
          }
          return clone;
        });

      const prepend = document.createDocumentFragment();
      const append = document.createDocumentFragment();

      cloneCards(originals).reverse().forEach((clone) => prepend.appendChild(clone));
      cloneCards(originals).forEach((clone) => append.appendChild(clone));

      carousel.prepend(prepend);
      carousel.append(append);

      const measureLoopWidth = () => {
        const cardWidth = originals[0].getBoundingClientRect().width;
        const styles = getComputedStyle(carousel);
        const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return (cardWidth + gap) * originals.length;
      };

      const resetToMiddle = () => {
        const width = measureLoopWidth();
        carousel.scrollLeft = width;
      };

      requestAnimationFrame(resetToMiddle);

      let rafId = 0;
      const normalizeScroll = () => {
        window.cancelAnimationFrame(rafId);
        rafId = window.requestAnimationFrame(() => {
          const width = measureLoopWidth();
          const total = carousel.scrollWidth;
          const leftEdge = width * 0.45;
          const rightEdge = total - carousel.clientWidth - width * 0.45;

          if (carousel.scrollLeft <= leftEdge) {
            carousel.scrollLeft += width;
          } else if (carousel.scrollLeft >= rightEdge) {
            carousel.scrollLeft -= width;
          }
        });
      };

      carousel.addEventListener('scroll', normalizeScroll, { passive: true });
      window.addEventListener('resize', resetToMiddle, { passive: true });
    };

    const initGiftCombo = (section) => {
      if (!section || section.dataset.ready === 'true') return;
      section.dataset.ready = 'true';

      const tabs = Array.from(section.querySelectorAll('[data-gift-tab]'));
      const panels = Array.from(section.querySelectorAll('[data-gift-panel]'));
      const cards = Array.from(section.querySelectorAll('.balad-gift-combo__carousel > [data-gift-card]'));
      const selectedIds = [];

      const locale = section.dataset.locale || document.documentElement.lang || navigator.language || 'en-IN';
      const currency = section.dataset.currency || 'INR';
      const cartAddUrl = section.dataset.cartAddUrl || '/cart/add';
      const discountThreshold = Number(section.dataset.discountThreshold || 99900);
      const discountPercent = Number(section.dataset.discountPercent || 5);

      const summaryList = section.querySelector('[data-gift-summary-list]');
      const subtotalNode = section.querySelector('[data-gift-subtotal]');
      const savingsNode = section.querySelector('[data-gift-savings]');
      const totalNode = section.querySelector('[data-gift-total]');
      const discountRow = section.querySelector('[data-gift-discount-row]');
      const progressFill = section.querySelector('[data-gift-progress]');
      const progressCopy = section.querySelector('[data-gift-progress-copy]');
      const countNode = section.querySelector('[data-gift-count]');
      const addButton = section.querySelector('[data-gift-add]');
      const addLabel = section.querySelector('[data-gift-add-label]');
      const resetButton = section.querySelector('[data-gift-reset]');

      const cardsById = new Map(cards.map((card) => [card.dataset.giftId, card]));
      const carousel = section.querySelector('[data-gift-carousel]');
      if (carousel) {
        setupLoopCarousel(carousel);
      }

      const selectedCards = () => selectedIds.map((id) => cardsById.get(id)).filter(Boolean);

      const updateCardState = () => {
        cards.forEach((card) => {
          const isSelected = selectedIds.includes(card.dataset.giftId);
          card.classList.toggle('is-selected', isSelected);
          card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });
      };

      const renderSummary = () => {
        const items = selectedCards();
        const subtotal = items.reduce((sum, card) => sum + Number(card.dataset.price || 0), 0);
        const thresholdReached = subtotal >= discountThreshold;
        const savings = thresholdReached ? Math.round((subtotal * discountPercent) / 100) : 0;
        const total = subtotal - savings;
        const progress = discountThreshold > 0 ? Math.min((subtotal / discountThreshold) * 100, 100) : 0;

        if (countNode) countNode.textContent = `${items.length} selected`;
        if (subtotalNode) subtotalNode.textContent = formatMoney(subtotal, locale, currency);
        if (savingsNode) savingsNode.textContent = formatMoney(savings, locale, currency);
        if (totalNode) totalNode.textContent = formatMoney(total, locale, currency);
        if (progressFill) progressFill.style.width = `${progress}%`;
        if (discountRow) discountRow.hidden = !thresholdReached || savings <= 0;

        if (progressCopy) {
          if (!items.length) {
            progressCopy.textContent = 'Start selecting products';
          } else if (thresholdReached) {
            progressCopy.textContent = `${discountPercent}% savings unlocked`;
          } else {
            const remaining = Math.max(discountThreshold - subtotal, 0);
            progressCopy.textContent = `${formatMoney(remaining, locale, currency)} left to unlock ${discountPercent}% off`;
          }
        }

        if (summaryList) {
          if (!items.length) {
            summaryList.innerHTML =
              '<p class="balad-gift-combo__empty">Choose products from one or more occasion tabs. The combo stays in sync as you add or remove items.</p>';
          } else {
              summaryList.innerHTML = items
              .map((card) => {
                const title = card.dataset.title || 'Product';
                const price = card.dataset.price || 0;
                return `
                  <p class="balad-gift-combo__summary-item" data-selected-item="${card.dataset.giftId}">
                    <span>
                      ${escapeHtml(title)}
                      <small>${escapeHtml(card.dataset.collection || '')}</small>
                    </span>
                    <strong>
                      ${formatMoney(price, locale, currency)}
                      <button type="button" data-remove-gift-id="${card.dataset.giftId}" aria-label="Remove ${escapeHtml(title)}">Remove</button>
                    </strong>
                  </p>
                `;
              })
              .join('');
          }
        }

        if (addButton) {
          addButton.disabled = items.length === 0;
        }
        if (addLabel) {
          if (!items.length) {
            addLabel.textContent = 'Pick items to continue';
          } else {
          addLabel.textContent = thresholdReached ? 'Add combo with savings' : 'Add room combo';
          }
        }

        updateCardState();
      };

      const activatePanel = (targetId) => {
        tabs.forEach((tab) => {
          const isActive = tab.dataset.target === targetId;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach((panel) => {
          const isActive = panel.id === targetId;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      };

      const addCard = (card) => {
        if (card.dataset.available === 'false') {
          showToast(section, 'This product is sold out.');
          return;
        }

        if (selectedIds.includes(card.dataset.giftId)) return;

        selectedIds.push(card.dataset.giftId);
        renderSummary();
      };

      const removeCard = (giftId) => {
        const index = selectedIds.indexOf(giftId);
        if (index === -1) return;
        selectedIds.splice(index, 1);
        renderSummary();
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => activatePanel(tab.dataset.target));
      });

      section.addEventListener('click', (event) => {
        const removeButton = event.target.closest('[data-remove-gift-id]');
        if (removeButton) {
          event.preventDefault();
          removeCard(removeButton.dataset.removeGiftId);
          return;
        }

        const toggleButton = event.target.closest('[data-gift-card-toggle]');
        if (toggleButton) {
          const card = toggleButton.closest('[data-gift-card]');
          if (!card) return;
          event.preventDefault();
          if (selectedIds.includes(card.dataset.giftId)) {
            removeCard(card.dataset.giftId);
          } else {
            addCard(card);
          }
          return;
        }

        const card = event.target.closest('[data-gift-card]');
        if (!card) return;

        event.preventDefault();
        if (selectedIds.includes(card.dataset.giftId)) {
          removeCard(card.dataset.giftId);
        } else {
          addCard(card);
        }
      });

      section.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        const card = event.target.closest('[data-gift-card]');
        if (!card) return;
        event.preventDefault();
        if (selectedIds.includes(card.dataset.giftId)) {
          removeCard(card.dataset.giftId);
        } else {
          addCard(card);
        }
      });

      addButton?.addEventListener('click', async () => {
        const items = selectedCards().map((card) => ({
          id: Number(card.dataset.variantId),
          quantity: 1,
        }));

        addButton.disabled = true;
        addButton.dataset.loading = 'true';

        try {
          const response = await fetch(`${cartAddUrl}.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ items }),
          });

          const cart = await response.json();
          if (!response.ok || cart?.status) {
            throw new Error(cart?.description || cart?.message || 'Add to cart failed');
          }

          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                data: {
                  source: 'balad-gift-combo',
                  itemCount: cart.item_count,
                },
              },
            })
          );

          syncHeaderCartCount(cart.item_count);
          showToast(section, 'Your room combo was added to cart.');
          openCartDrawer();
        } catch (error) {
          console.error(error);
          showToast(section, 'We could not add the combo. Please try again.');
        } finally {
          addButton.disabled = selectedIds.length === 0;
          addButton.dataset.loading = 'false';
          renderSummary();
        }
      });

      resetButton?.addEventListener('click', () => {
        selectedIds.length = 0;
        renderSummary();
      });

      const initialTab = tabs.find((tab) => tab.classList.contains('is-active')) || tabs[0];
      if (initialTab?.dataset.target) {
        activatePanel(initialTab.dataset.target);
      }

      renderSummary();
    };

    const initAll = (root = document) => {
      root.querySelectorAll('[data-balad-gift-combo]').forEach(initGiftCombo);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["balad-minimal-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const initHero = () => {
      document.querySelectorAll('[data-balad-min-hero]').forEach((hero) => {
        if (hero.dataset.initialized === 'true') return;
        hero.dataset.initialized = 'true';

        // Subtract announcement bar height so the mobile hero fits the visible screen exactly
        const setAnnounceH = () => {
          const bar = document.querySelector('.balad-announce');
          hero.style.setProperty('--hero-announce-h', (bar ? bar.offsetHeight : 0) + 'px');
        };
        setAnnounceH();
        window.addEventListener('resize', setAnnounceH);
        window.addEventListener('load', setAnnounceH);

        const viewport = hero.querySelector('.balad-min-hero__viewport');
        const track = hero.querySelector('[data-track]');
        const slides = Array.from(hero.querySelectorAll('[data-slide]'));
        const dots = Array.from(hero.querySelectorAll('[data-dot]'));
        const total = slides.length;
        if (total <= 1 || !track || !viewport) return;

        const autoplayMs = parseInt(hero.dataset.autoplay, 10) || 0;

        let currentIndex = 0;
        let autoplayTimer = null;

        const setActive = (idx) => {
          slides.forEach((s, i) => {
            s.classList.toggle('is-active', i === idx);
            s.setAttribute('aria-hidden', i === idx ? 'false' : 'true');
          });
          dots.forEach((d, i) => {
            d.classList.toggle('is-active', i === idx);
            d.setAttribute('aria-selected', i === idx ? 'true' : 'false');
          });
        };

        const render = (offsetPx) => {
          track.style.transform = offsetPx
            ? `translate3d(calc(${-currentIndex * 100}% + ${offsetPx}px), 0, 0)`
            : `translate3d(${-currentIndex * 100}%, 0, 0)`;
        };

        const goToSlide = (newIndex) => {
          currentIndex = (newIndex + total) % total;
          render(0);
          setActive(currentIndex);
          startAutoplay();
        };

        const startAutoplay = () => {
          if (autoplayTimer) clearInterval(autoplayTimer);
          if (autoplayMs > 0) {
            autoplayTimer = setInterval(() => goToSlide(currentIndex + 1), autoplayMs);
          }
        };

        const stopAutoplay = () => {
          if (autoplayTimer) clearInterval(autoplayTimer);
        };

        dots.forEach((dot) => {
          dot.addEventListener('click', () => goToSlide(parseInt(dot.dataset.dot, 10) || 0));
        });

        // ---- Live drag / swipe: the banner follows the finger or mouse ----
        let dragging = false;
        let startX = 0;
        let startY = 0;
        let dx = 0;
        let axis = null;
        let moved = false;

        const onDown = (e) => {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          if (e.target.closest('[data-dot]')) return;
          dragging = true;
          moved = false;
          axis = null;
          dx = 0;
          startX = e.clientX;
          startY = e.clientY;
          stopAutoplay();
        };

        const onMove = (e) => {
          if (!dragging) return;
          const mx = e.clientX - startX;
          const my = e.clientY - startY;

          if (axis === null && (Math.abs(mx) > 6 || Math.abs(my) > 6)) {
            axis = Math.abs(mx) > Math.abs(my) ? 'x' : 'y';
            if (axis === 'x') viewport.classList.add('is-dragging');
          }
          if (axis === 'y') { dragging = false; startAutoplay(); return; }
          if (axis !== 'x') return;

          moved = true;
          dx = mx;
          // rubber-band resistance at the first / last slide
          if ((currentIndex === 0 && dx > 0) || (currentIndex === total - 1 && dx < 0)) {
            dx *= 0.35;
          }
          render(dx);
        };

        const onEnd = () => {
          if (!dragging) return;
          dragging = false;
          viewport.classList.remove('is-dragging');
          if (axis !== 'x') { startAutoplay(); return; }

          const threshold = Math.min(viewport.offsetWidth * 0.15, 120);
          if (dx < -threshold && currentIndex < total - 1) {
            goToSlide(currentIndex + 1);
          } else if (dx > threshold && currentIndex > 0) {
            goToSlide(currentIndex - 1);
          } else {
            render(0);
            startAutoplay();
          }
          setTimeout(() => { moved = false; }, 60);
        };

        if (window.PointerEvent) {
          viewport.addEventListener('pointerdown', onDown);
          window.addEventListener('pointermove', onMove, { passive: true });
          window.addEventListener('pointerup', onEnd);
          window.addEventListener('pointercancel', onEnd);
        } else {
          viewport.addEventListener('touchstart', (e) => onDown(e.touches[0]), { passive: true });
          window.addEventListener('touchmove', (e) => onMove(e.touches[0]), { passive: true });
          window.addEventListener('touchend', onEnd);
          viewport.addEventListener('mousedown', onDown);
          window.addEventListener('mousemove', onMove);
          window.addEventListener('mouseup', onEnd);
        }

        // don't follow the slide link after a drag
        viewport.addEventListener('click', (e) => {
          if (moved) { e.preventDefault(); e.stopPropagation(); }
        }, true);

        hero.addEventListener('mouseenter', stopAutoplay);
        hero.addEventListener('mouseleave', () => { if (!dragging) startAutoplay(); });

        setActive(0);
        startAutoplay();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHero);
    } else {
      initHero();
    }

    document.addEventListener('shopify:section:load', initHero);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["balad-spotlight"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initDrawerSpotlight = (scope = document) => {
      scope.querySelectorAll('[data-balad-spotlight]').forEach((section) => {
        if (section.dataset.ready === 'true') return;
        section.dataset.ready = 'true';

        const panels = Array.from(section.querySelectorAll('[data-spotlight-panel]'));
        const seeAllBottom = section.querySelector('[data-spotlight-see-all-bottom]');
        const prevBtn = section.querySelector('[data-spotlight-nav="prev"]');
        const nextBtn = section.querySelector('[data-spotlight-nav="next"]');
        const bottomRowEl = section.querySelector('[data-spotlight-bottom-nav-row]');
        const cartAddUrl = section.dataset.cartAddUrl || '/cart/add';
        const noResults = section.querySelector('[data-spotlight-no-results]');
        const activeFiltersEl = section.querySelector('[data-spotlight-active-filters]');
        const activeTagEl = section.querySelector('[data-spotlight-active-tag]');
        const resultsCountEl = section.querySelector('[data-spotlight-results-count]');

        // Drawer elements
        const drawer = section.querySelector('[data-spotlight-drawer]');
        const drawerOverlay = section.querySelector('[data-spotlight-drawer-overlay]');
        const drawerTrigger = section.querySelector('[data-spotlight-drawer-trigger]');
        const drawerCloseBtns = Array.from(section.querySelectorAll('[data-spotlight-drawer-close]'));
        const filterBadge = section.querySelector('[data-spotlight-filter-badge]');

        // ---- State ----
        let activeCollectionPanelId = null;
        let activeCategory = 'all';
        let activeSubcategory = 'all';
        let activePrice = 'all';
        let activeSort = 'best-selling';

        // ---- Drawer Actions ----
        const openDrawer = () => {
          if (!drawer) return;
          drawer.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden'; // prevent scrolling underneath
        };

        const closeDrawer = () => {
          if (!drawer) return;
          drawer.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        };

        if (drawerTrigger) {
          drawerTrigger.addEventListener('click', openDrawer);
        }

        if (drawerOverlay) {
          drawerOverlay.addEventListener('click', closeDrawer);
        }

        drawerCloseBtns.forEach((btn) => btn.addEventListener('click', closeDrawer));

        // ESC key to close
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && drawer && drawer.getAttribute('aria-hidden') === 'false') {
            closeDrawer();
          }
        });

        // ---- Collection switching ----
        const activateCollection = (targetId) => {
          activeCollectionPanelId = targetId;

          // Toggle drawer option UI
          section.querySelectorAll('[data-spotlight-collection-tab-ref]').forEach((btn) => {
            const isActive = btn.dataset.spotlightCollectionTabRef === targetId;
            btn.classList.toggle('is-active', isActive);
          });

          // Toggle panel views
          panels.forEach((panel) => {
            const isActive = panel.id === targetId;
            panel.classList.toggle('is-active', isActive);
            panel.hidden = !isActive;

            if (isActive && seeAllBottom && panel.dataset.spotlightUrl) {
              seeAllBottom.href = panel.dataset.spotlightUrl;
            }
          });

          applyFilters();
        };

        section.querySelectorAll('[data-spotlight-collection-filters]').forEach((group) => {
          group.addEventListener('click', (e) => {
            const btn = e.target.closest('[data-spotlight-collection-tab-ref]');
            if (!btn) return;
            activateCollection(btn.dataset.spotlightCollectionTabRef);
          });
        });

        // ---- Category filter ----
        section.querySelectorAll('[data-spotlight-category-filters]').forEach((group) => {
          group.addEventListener('click', (e) => {
            const item = e.target.closest('[data-spotlight-category]');
            if (!item) return;
            group.querySelectorAll('[data-spotlight-category]').forEach((c) => c.classList.remove('is-active'));
            item.classList.add('is-active');
            activeCategory = item.dataset.spotlightCategory;
            applyFilters();
          });
        });

        // ---- Sub-category filter ----
        section.querySelectorAll('[data-spotlight-subcategory-filters]').forEach((group) => {
          group.addEventListener('click', (e) => {
            const item = e.target.closest('[data-spotlight-subcategory]');
            if (!item) return;
            group.querySelectorAll('[data-spotlight-subcategory]').forEach((c) => c.classList.remove('is-active'));
            item.classList.add('is-active');
            activeSubcategory = item.dataset.spotlightSubcategory;
            applyFilters();
          });
        });

        // ---- Price filter ----
        section.querySelectorAll('[data-spotlight-price-filters]').forEach((group) => {
          group.addEventListener('click', (e) => {
            const item = e.target.closest('[data-spotlight-price]');
            if (!item) return;
            group.querySelectorAll('[data-spotlight-price]').forEach((c) => c.classList.remove('is-active'));
            item.classList.add('is-active');
            activePrice = item.dataset.spotlightPrice;
            applyFilters();
          });
        });

        // ---- Sort options ----
        section.querySelectorAll('[data-spotlight-sort-options]').forEach((group) => {
          group.addEventListener('click', (e) => {
            const item = e.target.closest('[data-spotlight-sort-val]');
            if (!item) return;
            group.querySelectorAll('[data-spotlight-sort-val]').forEach((c) => c.classList.remove('is-active'));
            item.classList.add('is-active');
            activeSort = item.dataset.spotlightSortVal;
            applyFilters();
          });
        });

        // ---- Clear filters ----
        const clearFilters = () => {
          activeCategory = 'all';
          activeSubcategory = 'all';
          activePrice = 'all';
          activeSort = 'best-selling';

          section.querySelectorAll('[data-spotlight-category]').forEach((c) => {
            c.classList.toggle('is-active', c.dataset.spotlightCategory === 'all');
          });
          section.querySelectorAll('[data-spotlight-subcategory]').forEach((c) => {
            c.classList.toggle('is-active', c.dataset.spotlightSubcategory === 'all');
          });
          section.querySelectorAll('[data-spotlight-price]').forEach((c) => {
            c.classList.toggle('is-active', c.dataset.spotlightPrice === 'all');
          });
          section.querySelectorAll('[data-spotlight-sort-val]').forEach((c) => {
            c.classList.toggle('is-active', c.dataset.spotlightSortVal === 'best-selling');
          });

          applyFilters();
        };

        const clearBtn = section.querySelector('[data-spotlight-clear-filters]');
        if (clearBtn) {
          clearBtn.addEventListener('click', clearFilters);
        }

        // ---- Filtering + Sorting ----
        const applyFilters = () => {
          const currentPanel = panels.find((p) => p.id === activeCollectionPanelId);
          if (!currentPanel) return;

          const carousel = currentPanel.querySelector('.balad-spotlight__carousel');
          if (!carousel) return;

          const cards = Array.from(carousel.querySelectorAll('.balad-spotlight-card'));
          let visibleCount = 0;

          cards.forEach((card) => {
            const cardType = (card.dataset.productType || '').toLowerCase();
            const cardPrice = parseInt(card.dataset.productPrice || '0', 10) / 100;
            const cardTags = (card.dataset.productTags || '').split(',');

            let showByCategory = activeCategory === 'all' || cardType === activeCategory;
            let showBySubcategory = activeSubcategory === 'all' || cardTags.includes(activeSubcategory);
            let showByPrice = true;

            if (activePrice !== 'all') {
              const parts = activePrice.split('-');
              const min = parseInt(parts[0], 10);
              const max = parseInt(parts[1], 10);
              showByPrice = cardPrice >= min && cardPrice <= max;
            }

            const visible = showByCategory && showBySubcategory && showByPrice;
            card.dataset.filtered = visible ? 'false' : 'true';
            if (visible) visibleCount++;
          });

          // Sort visible cards
          const visibleCards = cards.filter((c) => c.dataset.filtered !== 'true');
          const priceAsc = (a, b) => parseInt(a.dataset.productPrice || '0') - parseInt(b.dataset.productPrice || '0');
          const priceDesc = (a, b) => parseInt(b.dataset.productPrice || '0') - parseInt(a.dataset.productPrice || '0');
          const titleAsc = (a, b) => (a.dataset.productTitle || '').localeCompare(b.dataset.productTitle || '');
          const titleDesc = (a, b) => (b.dataset.productTitle || '').localeCompare(a.dataset.productTitle || '');

          const sortMap = {
            'best-selling': null,
            'price-ascending': priceAsc,
            'price-descending': priceDesc,
            'title-ascending': titleAsc,
            'title-descending': titleDesc,
          };

          const sortFn = sortMap[activeSort];
          if (sortFn) {
            visibleCards.sort(sortFn);
            visibleCards.forEach((card) => carousel.appendChild(card));
          }

          // Update active filters badge count
          let activeCount = 0;
          if (activeCategory !== 'all') activeCount++;
          if (activeSubcategory !== 'all') activeCount++;
          if (activePrice !== 'all') activeCount++;
          if (activeSort !== 'best-selling') activeCount++;
          if (filterBadge) {
            filterBadge.textContent = activeCount;
            filterBadge.style.display = activeCount > 0 ? 'inline-flex' : 'none';
          }

          // Update active filter tags banner on homepage
          if (activeFiltersEl) {
            const tags = [];
            if (activeCategory !== 'all') {
              const catItem = section.querySelector(`[data-spotlight-category="${activeCategory}"]`);
              tags.push(catItem?.dataset.spotlightCategoryLabel || activeCategory);
            }
            if (activeSubcategory !== 'all') {
              const subItem = section.querySelector(`[data-spotlight-subcategory="${activeSubcategory}"]`);
              tags.push(subItem?.dataset.spotlightSubcategoryLabel || activeSubcategory);
            }
            if (activePrice !== 'all') {
              const priceItem = section.querySelector(`[data-spotlight-price="${activePrice}"]`);
              tags.push(priceItem?.dataset.spotlightPriceLabel || activePrice);
            }

            if (tags.length > 0) {
              activeFiltersEl.style.display = 'flex';
              activeTagEl.textContent = tags.join(' · ');
            } else {
              activeFiltersEl.style.display = 'none';
            }
          }

          // Results count
          if (resultsCountEl) {
            resultsCountEl.textContent = `${visibleCount} product${visibleCount !== 1 ? 's' : ''} found`;
          }

          // No results
          if (noResults) {
            noResults.style.display = visibleCount === 0 ? 'block' : 'none';
          }

          // Hide bottom row if no results matching filters
          if (bottomRowEl) {
            bottomRowEl.style.display = visibleCount === 0 ? 'none' : 'flex';
          }
        };

        // ---- Add to Cart ----
        section.querySelectorAll('[data-balad-spotlight-add]').forEach((button) => {
          button.addEventListener('click', async (event) => {
            event.preventDefault();
            const form = button.closest('form');
            const variantId = form?.querySelector('input[name="id"]')?.value;
            if (!variantId) return;

            button.disabled = true;
            button.dataset.loading = 'true';

            try {
              const response = await fetch(`${cartAddUrl}.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
              });

              const cart = await response.json();
              if (!response.ok || cart?.status) {
                throw new Error(cart?.description || cart?.message || 'Add to cart failed');
              }

              document.dispatchEvent(
                new CustomEvent('cart:update', {
                  bubbles: true,
                  detail: {
                    resource: cart,
                    data: { source: 'balad-spotlight', itemCount: cart.item_count },
                  },
                })
              );

              document.querySelector('[data-testid="cart-drawer-trigger"]')?.click();
            } catch (error) {
              console.error(error);
            } finally {
              button.disabled = false;
              button.dataset.loading = 'false';
            }
          });
        });

        // ---- Navigation Scrolling ----
        const getActiveCarousel = () => {
          const currentPanel = panels.find((p) => p.id === activeCollectionPanelId);
          return currentPanel?.querySelector('.balad-spotlight__carousel');
        };

        if (prevBtn) {
          prevBtn.addEventListener('click', () => {
            const carousel = getActiveCarousel();
            if (carousel) {
              const card = carousel.querySelector('.balad-spotlight-card');
              const scrollVal = card ? card.offsetWidth + 20 : 320;
              carousel.scrollBy({ left: -scrollVal, behavior: 'smooth' });
            }
          });
        }

        if (nextBtn) {
          nextBtn.addEventListener('click', () => {
            const carousel = getActiveCarousel();
            if (carousel) {
              const card = carousel.querySelector('.balad-spotlight-card');
              const scrollVal = card ? card.offsetWidth + 20 : 320;
              carousel.scrollBy({ left: scrollVal, behavior: 'smooth' });
            }
          });
        }

        // ---- Init ----
        const initialOption = section.querySelector('[data-spotlight-collection-tab-ref].is-active') || section.querySelector('[data-spotlight-collection-tab-ref]');
        const initialTargetId = initialOption?.dataset.spotlightCollectionTabRef;
        if (initialTargetId) {
          activateCollection(initialTargetId);
        } else {
          applyFilters();
        }
      });
    };

    document.addEventListener('DOMContentLoaded', () => initDrawerSpotlight());
    document.addEventListener('shopify:section:load', (event) => initDrawerSpotlight(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.pf-contact-form').forEach((section) => {
      if (section.dataset.init === 'true') return;
      section.dataset.init = 'true';

      const chips = section.querySelectorAll('.pf-chip');
      const subjectInput = section.querySelector('#ContactFormSubject');

      chips.forEach((chip) => {
        chip.addEventListener('click', () => {
          chips.forEach((c) => c.classList.remove('is-active'));
          chip.classList.add('is-active');
          if (subjectInput) {
            subjectInput.value = chip.dataset.topic || chip.textContent.trim();
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // -------------------------------------------------------------
    // Header & Drawer Logic
    // -------------------------------------------------------------
    const header = document.querySelector('[data-pf-header]');
    const drawer = document.querySelector('[data-pf-header-drawer]');
    const openButtons = document.querySelectorAll('[data-pf-header-menu]');
    const closeButtons = document.querySelectorAll('[data-pf-header-close]');

    if (drawer && drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }

    let currentScrolledState = null;
    let headerScrollTicking = false;

    const updateHeaderMetrics = () => {
      if (!header) return;
      const h = header.offsetHeight;
      const headerGroup = document.querySelector('#header-group') || header.closest('.shopify-section-group-header-group');
      const totalH = headerGroup && headerGroup.offsetHeight > h ? headerGroup.offsetHeight : h;
      if (h > 0) {
        document.documentElement.style.setProperty('--header-height', h + 'px');
        document.documentElement.style.setProperty('--header-height-mobile', h + 'px');
        document.documentElement.style.setProperty('--header-group-height', totalH + 'px');
      }
    };

    const setScrollState = () => {
      if (!header) return;
      const isScrolled = window.scrollY > 10;
      if (currentScrolledState !== isScrolled) {
        currentScrolledState = isScrolled;
        const stateStr = isScrolled ? 'true' : 'false';
        header.dataset.scrolled = stateStr;
        header.setAttribute('data-scrolled', stateStr);
      }
    };

    const onHeaderScroll = () => {
      if (!headerScrollTicking) {
        window.requestAnimationFrame(() => {
          setScrollState();
          headerScrollTicking = false;
        });
        headerScrollTicking = true;
      }
    };

    const toggleMobileNav = (hide) => {
      const mobileNavs = document.querySelectorAll('[data-balad-mobile-nav], .balad-mobile-nav, .balad-mobile-tabs');
      mobileNavs.forEach((nav) => {
        if (hide) {
          nav.setAttribute('data-hidden', 'true');
          nav.style.setProperty('display', 'none', 'important');
        } else {
          nav.removeAttribute('data-hidden');
          nav.style.removeProperty('display');
        }
      });
    };

    const openDrawer = (e) => {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      if (!drawer) return;
      drawer.hidden = false;
      drawer.removeAttribute('hidden');
      document.body.classList.add('pf-drawer-open');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      toggleMobileNav(true);
    };

    const closeDrawer = (e) => {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      if (!drawer) return;
      drawer.hidden = true;
      drawer.setAttribute('hidden', 'true');
      document.body.classList.remove('pf-drawer-open');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      toggleMobileNav(false);
    };

    openButtons.forEach((button) => button.addEventListener('click', openDrawer));
    closeButtons.forEach((button) => button.addEventListener('click', closeDrawer));
    drawer?.addEventListener('click', (event) => {
      if (event.target === drawer) closeDrawer();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer && !drawer.hidden) {
        closeDrawer();
      }
    });

    const updateCartCount = (count) => {
      const countNodes = document.querySelectorAll('.pf-header__cart-count');
      countNodes.forEach((countNode) => {
        if (count > 0) {
          countNode.textContent = count;
          countNode.removeAttribute('hidden');
          countNode.removeAttribute('aria-hidden');
        } else {
          countNode.textContent = '0';
          countNode.setAttribute('hidden', 'true');
          countNode.setAttribute('aria-hidden', 'true');
        }
      });
    };

    document.addEventListener('cart:update', (event) => {
      let count = 0;
      if (event.detail?.resource?.items !== undefined) {
        count = event.detail.resource.items.length;
      } else if (event.detail?.resource?.item_count !== undefined) {
        count = event.detail.resource.items ? event.detail.resource.items.length : Number(event.detail.resource.item_count);
      } else {
        const comingFromProductForm = event.detail?.data?.source === 'product-form-component';
        const currentCountNode = document.querySelector('.pf-header__cart-count');
        const currentCount = currentCountNode ? Number(currentCountNode.textContent) : 0;
        count = comingFromProductForm ? currentCount + Number(event.detail?.data?.itemCount ?? 0) : Number(event.detail?.data?.itemCount ?? 0);
      }
      updateCartCount(count);
    });

    updateHeaderMetrics();
    setScrollState();
    window.addEventListener('scroll', onHeaderScroll, { passive: true });
    window.addEventListener('resize', () => {
      updateHeaderMetrics();
      setScrollState();
    }, { passive: true });

    // -------------------------------------------------------------
    // Desktop dropdowns: open on hover, close on leave / outside click / Esc
    // -------------------------------------------------------------
    const dropdowns = document.querySelectorAll('.pf-header__menu');
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
    dropdowns.forEach((menu) => {
      let closeTimer;
      menu.addEventListener('mouseenter', () => {
        if (!canHover.matches) return;
        clearTimeout(closeTimer);
        dropdowns.forEach((other) => { if (other !== menu) other.removeAttribute('open'); });
        menu.setAttribute('open', '');
      });
      menu.addEventListener('mouseleave', () => {
        if (!canHover.matches) return;
        closeTimer = setTimeout(() => menu.removeAttribute('open'), 160);
      });
    });
    document.addEventListener('click', (event) => {
      dropdowns.forEach((menu) => { if (!menu.contains(event.target)) menu.removeAttribute('open'); });
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') dropdowns.forEach((menu) => menu.removeAttribute('open'));
    });

    // -------------------------------------------------------------
    // Clean Structured Story Modal Logic & Instant Preload Fix
    // -------------------------------------------------------------
    const storyModal = document.getElementById('pf-story-modal');
    const openStoryBtns = document.querySelectorAll('[data-open-story-modal]');
    const closeStoryBtns = document.querySelectorAll('[data-story-close]');
    const storyDataScript = document.getElementById('pf-story-data');

    if (storyModal) {
      // Ensure modal is moved to <body> so sticky header & backdrop-filter don't trap or clip it
      if (storyModal.parentElement !== document.body) {
        document.body.appendChild(storyModal);
      }

      let stories = [];
      if (storyDataScript && storyDataScript.textContent.trim()) {
        try {
          const sanitized = storyDataScript.textContent.trim().replace(/,\s*([\]}])/g, '$1');
          stories = JSON.parse(sanitized);
        } catch (e) {
          console.warn('Error parsing story data, using fallback stories', e);
        }
      }

      // Hardened fallback: ensure stories array is never empty so modal ALWAYS opens
      if (!Array.isArray(stories) || stories.length === 0) {
        stories = [
          {
            image: "https://images.unsplash.com/photo-1594035910387-fea47794261f?auto=format&fit=crop&w=1200&q=80",
            tag: "Find Your Signature Scent",
            link: "/collections/all",
            btn_text: "Shop Now"
          },
          {
            image: "https://images.unsplash.com/photo-1594035910387-fea47794261f?auto=format&fit=crop&w=1200&q=80",
            tag: "Find Your Signature Scent",
            link: "/collections/all",
            btn_text: "Shop Now"
          }
        ];
      }

      const progressContainer = storyModal.querySelector('[data-story-progress-container]');
      const storyImage = storyModal.querySelector('[data-story-image]');
      const storyLoader = storyModal.querySelector('[data-story-loader]');
      const storyTag = storyModal.querySelector('[data-story-tag]');
      const storyFooterTag = storyModal.querySelector('[data-story-footer-tag]');
      const storyCta = storyModal.querySelector('[data-story-cta]');
      const storyBtnText = storyModal.querySelector('[data-story-btn-text]');
      const prevBtns = storyModal.querySelectorAll('[data-story-prev], [data-story-tap-prev]');
      const nextBtns = storyModal.querySelectorAll('[data-story-next], [data-story-tap-next]');
      const pauseBtn = storyModal.querySelector('[data-story-pause]');
      const pauseIcon = pauseBtn?.querySelector('.pf-story-modal__pause-icon');
      const playIcon = pauseBtn?.querySelector('.pf-story-modal__play-icon');
      const cardElement = storyModal.querySelector('[data-story-card]');

      let currentIndex = 0;
      let isPaused = false;
      let isImageLoading = false;
      let progressInterval = null;
      const DURATION_MS = 5000;
      const TICK_MS = 30;
      let elapsedMs = 0;

      // Image preload cache to ensure instantaneous transitions
      const preloadedImages = new Map();

      const preloadAllImages = () => {
        stories.forEach((item) => {
          if (item && item.image && !preloadedImages.has(item.image)) {
            const img = new Image();
            img.onload = () => {
              preloadedImages.set(item.image, img);
            };
            img.src = item.image;
          }
        });
      };
      // Story images are preloaded when modal is opened to avoid network contention during initial page load

      // Build Progress Segments
      const buildProgressBars = () => {
        if (!progressContainer) return;
        progressContainer.innerHTML = '';
        stories.forEach((_, idx) => {
          const segment = document.createElement('div');
          segment.className = 'pf-story-modal__progress-segment';
          segment.innerHTML = '<div class="pf-story-modal__progress-fill"></div>';
          segment.addEventListener('click', (e) => {
            e.stopPropagation();
            goToStory(idx);
          });
          progressContainer.appendChild(segment);
        });
      };

      const updateProgressBars = () => {
        const fills = progressContainer?.querySelectorAll('.pf-story-modal__progress-fill');
        if (!fills) return;

        fills.forEach((fill, idx) => {
          if (idx < currentIndex) {
            fill.style.width = '100%';
            fill.classList.add('is-finished');
          } else if (idx === currentIndex) {
            const pct = Math.min((elapsedMs / DURATION_MS) * 100, 100);
            fill.style.width = `${pct}%`;
            fill.classList.remove('is-finished');
          } else {
            fill.style.width = '0%';
            fill.classList.remove('is-finished');
          }
        });
      };

      let activeRenderToken = 0;

      const renderStory = (index) => {
        const item = stories[index];
        if (!item) return;

        const currentToken = ++activeRenderToken;

        // Immediately hide current image to prevent showing old/first image while switching
        if (storyImage) {
          storyImage.classList.remove('is-loaded');
        }

        // Update Text & Link content immediately
        if (storyTag) {
          storyTag.textContent = item.tag || 'Featured';
        }
        if (storyFooterTag) {
          storyFooterTag.textContent = item.tag || 'Featured';
        }
        if (storyCta) {
          storyCta.href = item.link || '#';
        }
        if (storyBtnText) {
          storyBtnText.textContent = item.btn_text || 'Shop Now';
        }

        elapsedMs = 0;
        updateProgressBars();

        // Check if image is already cached
        const preloaded = preloadedImages.get(item.image);
        const isAlreadyComplete = preloaded && preloaded.complete && preloaded.naturalWidth > 0;

        if (isAlreadyComplete) {
          if (storyLoader) storyLoader.classList.remove('is-active');
          isImageLoading = false;
          if (storyImage) {
            storyImage.src = item.image;
            storyImage.classList.add('is-loaded');
          }
        } else {
          // Show loader and pause progress while downloading
          if (storyLoader) storyLoader.classList.add('is-active');
          isImageLoading = true;

          const tempImg = new Image();
          tempImg.onload = () => {
            if (currentToken !== activeRenderToken) return;
            preloadedImages.set(item.image, tempImg);
            if (storyLoader) storyLoader.classList.remove('is-active');
            isImageLoading = false;
            if (storyImage) {
              storyImage.src = item.image;
              storyImage.classList.add('is-loaded');
            }
          };
          tempImg.onerror = () => {
            if (currentToken !== activeRenderToken) return;
            if (storyLoader) storyLoader.classList.remove('is-active');
            isImageLoading = false;
            if (storyImage) {
              const fallbackUrl = "https://images.unsplash.com/photo-1594035910387-fea47794261f?auto=format&fit=crop&w=1200&q=80";
              storyImage.src = fallbackUrl;
              storyImage.classList.add('is-loaded');
            }
          };
          tempImg.src = item.image;
        }
      };

      const startTimer = () => {
        clearInterval(progressInterval);
        progressInterval = setInterval(() => {
          if (isPaused || isImageLoading) return;

          elapsedMs += TICK_MS;
          updateProgressBars();

          if (elapsedMs >= DURATION_MS) {
            if (currentIndex < stories.length - 1) {
              currentIndex++;
              renderStory(currentIndex);
            } else {
              closeStory();
            }
          }
        }, TICK_MS);
      };

      const goToStory = (idx) => {
        if (idx < 0) {
          currentIndex = 0;
        } else if (idx >= stories.length) {
          closeStory();
          return;
        } else {
          currentIndex = idx;
        }
        renderStory(currentIndex);
      };

      const openStory = () => {
        if (storyModal.parentElement !== document.body) {
          document.body.appendChild(storyModal);
        }

        storyModal.removeAttribute('hidden');
        storyModal.hidden = false;
        storyModal.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        document.body.classList.add('story-modal-open');

        preloadAllImages();
        buildProgressBars();
        currentIndex = 0;
        isPaused = false;
        renderStory(0);

        requestAnimationFrame(() => {
          storyModal.classList.add('is-active');
        });

        startTimer();
      };

      const closeStory = () => {
        clearInterval(progressInterval);
        storyModal.classList.remove('is-active');
        storyModal.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
        document.body.classList.remove('story-modal-open');

        setTimeout(() => {
          storyModal.hidden = true;
          storyModal.setAttribute('hidden', '');
          if (storyImage) storyImage.classList.remove('is-loaded');
        }, 280);
      };

      const togglePause = (forcePause) => {
        if (typeof forcePause === 'boolean') {
          isPaused = forcePause;
        } else {
          isPaused = !isPaused;
        }

        if (pauseIcon && playIcon) {
          if (isPaused) {
            pauseIcon.style.display = 'none';
            playIcon.style.display = 'block';
          } else {
            pauseIcon.style.display = 'block';
            playIcon.style.display = 'none';
          }
        }
      };

      // Press & Hold to Pause Feature (Instagram Style)
      let holdTimer = null;
      let isHolding = false;

      if (cardElement) {
        const handleHoldStart = (e) => {
          if (e.target.closest('[data-story-close], [data-story-pause], [data-story-cta], .pf-story-modal__progress-segment')) {
            return;
          }
          holdTimer = setTimeout(() => {
            isHolding = true;
            togglePause(true);
          }, 180);
        };

        const handleHoldEnd = () => {
          clearTimeout(holdTimer);
          if (isHolding) {
            isHolding = false;
            togglePause(false);
          }
        };

        cardElement.addEventListener('mousedown', handleHoldStart);
        cardElement.addEventListener('mouseup', handleHoldEnd);
        cardElement.addEventListener('mouseleave', handleHoldEnd);
        cardElement.addEventListener('touchstart', handleHoldStart, { passive: true });
        cardElement.addEventListener('touchend', handleHoldEnd, { passive: true });
      }

      openStoryBtns.forEach((btn) => btn.addEventListener('click', openStory));
      closeStoryBtns.forEach((btn) => btn.addEventListener('click', closeStory));

      // Document-level event delegation for opening & closing reliably from anywhere
      document.addEventListener('click', (e) => {
        const openBtn = e.target.closest('[data-open-story-modal]');
        if (openBtn) {
          e.preventDefault();
          e.stopPropagation();
          openStory();
          return;
        }

        const closeBtn = e.target.closest('[data-story-close]');
        if (closeBtn && !storyModal.hidden) {
          e.preventDefault();
          e.stopPropagation();
          closeStory();
          return;
        }
      });

      prevBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          goToStory(currentIndex - 1);
        });
      });

      nextBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          goToStory(currentIndex + 1);
        });
      });

      pauseBtn?.addEventListener('click', (e) => {
        e.stopPropagation();
        togglePause();
      });

      // Keyboard support
      window.addEventListener('keydown', (e) => {
        if (storyModal.hidden) return;
        if (e.key === 'Escape') closeStory();
        if (e.key === 'ArrowLeft') goToStory(currentIndex - 1);
        if (e.key === 'ArrowRight') goToStory(currentIndex + 1);
        if (e.key === ' ') {
          e.preventDefault();
          togglePause();
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-pf-product]');
    if (!root) return;

    const slidesRail = root.querySelector('[data-pf-slides]');
    const slides = [...root.querySelectorAll('[data-pf-slide]')];
    const thumbs = [...root.querySelectorAll('[data-pf-thumb]')];
    const thumbsTrack = root.querySelector('[data-pf-thumbs]');
    const sizePills = [...root.querySelectorAll('[data-pf-size-pill]')];
    const variantIdInput = root.querySelector('[data-pf-variant-id]');
    const qtyField = root.querySelector('[data-pf-qty-field]');
    const addToBagBtn = root.querySelector('[data-pf-add-to-bag]');
    const buyNowBtn = root.querySelector('[data-pf-buy-now]');
    const addTextEl = root.querySelector('[data-pf-add-text]');
    const priceMainEl = root.querySelector('[data-pf-price-main]');
    const compareEl = root.querySelector('[data-pf-compare-price]');
    const offEl = root.querySelector('[data-pf-off-badge]');
    const stockEl = root.querySelector('[data-pf-stock]');
    const stockTextEl = root.querySelector('[data-pf-stock-text]');
    const deliveryEl = root.querySelector('[data-pf-delivery]');
    const stickyBar = root.querySelector('[data-pf-sticky-bar]');
    const stickyAddBtn = root.querySelector('[data-pf-sticky-add]');
    const stickyBuyBtn = root.querySelector('[data-pf-sticky-buy]');
    const stickyClose = root.querySelector('[data-pf-sticky-close]');
    const stickyAddText = root.querySelector('[data-pf-sticky-add-text]');
    const stickyPriceEl = root.querySelector('[data-pf-sticky-price]');
    const stickyCompareEl = root.querySelector('[data-pf-sticky-compare-price]');

    const variantDataEl = root.querySelector('[id^="VariantData-"]');
    const variantData = variantDataEl ? JSON.parse(variantDataEl.textContent) : [];
    const variantMap = {};
    if (Array.isArray(variantData)) variantData.forEach((v) => { variantMap[v.id] = v; });

    const formatMoney = (cents) => {
      const rupees = (Number(cents) || 0) / 100;
      return '\u20B9' + rupees.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    };

    // ── Gallery ──
    const desktopQuery = window.matchMedia('(min-width: 990px)');
    let lockUntil = 0; // while a thumbnail-triggered smooth scroll runs, ignore scroll events so the thumbs do not flicker

    const revealThumb = (thumb) => {
      if (!thumbsTrack || !thumb) return;
      const tr = thumbsTrack.getBoundingClientRect();
      const r = thumb.getBoundingClientRect();
      if (r.top < tr.top) thumbsTrack.scrollTop += r.top - tr.top;
      else if (r.bottom > tr.bottom) thumbsTrack.scrollTop += r.bottom - tr.bottom;
      if (r.left < tr.left) thumbsTrack.scrollLeft += r.left - tr.left;
      else if (r.right > tr.right) thumbsTrack.scrollLeft += r.right - tr.right;
    };

    const setActive = (index) => {
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.querySelectorAll('video').forEach((video) => {
          if (!active) video.pause();
          else if (video.autoplay) video.play().catch(() => {});
        });
      });
      thumbs.forEach((thumb, i) => {
        const active = i === index;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });
      revealThumb(thumbs[index]);
    };

    const goToSlide = (index) => {
      const slide = slides[index];
      if (!slide) return;
      if (!desktopQuery.matches && slidesRail) {
        lockUntil = Date.now() + 600;
        slidesRail.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
      setActive(index);
    };

    const goToMediaId = (mediaId) => {
      if (!mediaId) return;
      const index = slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
      if (index >= 0) goToSlide(index);
    };

    if (slides.length) {
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => goToSlide(parseInt(thumb.dataset.slideIndex, 10) || 0));
      });

      if (slidesRail) {
        let raf = 0;
        slidesRail.addEventListener('scroll', () => {
          if (desktopQuery.matches) return;
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => {
            if (Date.now() < lockUntil) return;
            const width = slidesRail.clientWidth || 1;
            const index = Math.max(0, Math.min(slides.length - 1, Math.round(slidesRail.scrollLeft / width)));
            setActive(index);
          });
        }, { passive: true });
      }
      setActive(0);
    }

    // ── Desktop: keep the details panel in view (and its bottom reachable if it is taller than the window) ──
    const infoPanel = root.querySelector('.pdp-info');
    if (infoPanel) {
      const placeInfo = () => {
        if (!desktopQuery.matches) { infoPanel.style.removeProperty('--pdp-info-top'); return; }
        const header = parseFloat(getComputedStyle(root).getPropertyValue('--header-group-height')) || 66;
        const base = header + 12;
        const fit = window.innerHeight - infoPanel.offsetHeight - 16;
        infoPanel.style.setProperty('--pdp-info-top', Math.min(base, fit) + 'px');
      };
      placeInfo();
      window.addEventListener('resize', placeInfo);
      if ('ResizeObserver' in window) new ResizeObserver(placeInfo).observe(infoPanel);
    }

    // ── Desktop: pin the photo block too. When the details are taller than the photos, the photos stay in view
    //    (at the top, or at the bottom edge if they are taller than the window) until the details end. ──
    const galleryEl = root.querySelector('[data-pf-gallery]');
    if (galleryEl) {
      const placeGallery = () => {
        if (!desktopQuery.matches) { galleryEl.style.removeProperty('--pdp-gallery-top'); return; }
        const header = parseFloat(getComputedStyle(root).getPropertyValue('--header-group-height')) || 66;
        const base = header + 12;
        const fit = window.innerHeight - galleryEl.offsetHeight - 16;
        galleryEl.style.setProperty('--pdp-gallery-top', Math.min(base, fit) + 'px');
      };
      placeGallery();
      window.addEventListener('resize', placeGallery);
      window.addEventListener('load', placeGallery);
      if ('ResizeObserver' in window) new ResizeObserver(placeGallery).observe(galleryEl);
    }

    // ── Estimated delivery date (calculated from today in the visitor's browser) ──
    if (deliveryEl) {
      const dispatch = parseInt(deliveryEl.dataset.dispatch, 10) || 0;
      const minDays = dispatch + (parseInt(deliveryEl.dataset.min, 10) || 3);
      const maxDays = dispatch + (parseInt(deliveryEl.dataset.max, 10) || 6);
      const rangeEl = deliveryEl.querySelector('[data-pf-delivery-range]');
      const fmt = (days) => {
        const d = new Date();
        d.setDate(d.getDate() + days);
        return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
      };
      if (rangeEl) rangeEl.textContent = fmt(minDays) + ' to ' + fmt(maxDays);
    }

    // ── Variant sync ──
    const syncVariant = (variantId) => {
      if (variantIdInput && variantId) variantIdInput.value = variantId;
      const v = variantMap[variantId];
      if (!v) return;

      const available = v.available;
      [addToBagBtn, buyNowBtn, stickyAddBtn, stickyBuyBtn].forEach((b) => { if (b) b.disabled = !available; });
      if (addTextEl) addTextEl.textContent = available ? 'Add to bag' : 'Sold out';
      if (stickyAddText) stickyAddText.textContent = available ? 'Add to bag' : 'Sold out';

      if (deliveryEl) deliveryEl.hidden = !available;
      if (stockEl) {
        stockEl.classList.toggle('is-in', !!available);
        stockEl.classList.toggle('is-out', !available);
      }
      if (stockTextEl) stockTextEl.textContent = available ? 'In Stock, Ready To Ship' : 'Sold Out';

      if (v.price != null) {
        const priceText = formatMoney(v.price);
        const hasDiscount = v.compare_at_price && v.compare_at_price > v.price;

        if (priceMainEl) priceMainEl.textContent = priceText;
        if (compareEl) {
          compareEl.textContent = hasDiscount ? formatMoney(v.compare_at_price) : '';
          compareEl.hidden = !hasDiscount;
        }
        if (offEl) {
          if (hasDiscount) {
            const pct = Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100);
            offEl.textContent = '(' + pct + '% OFF)';
          }
          offEl.hidden = !hasDiscount;
        }
        if (stickyPriceEl) stickyPriceEl.textContent = priceText;
        if (stickyCompareEl) {
          stickyCompareEl.textContent = hasDiscount ? formatMoney(v.compare_at_price) : '';
          stickyCompareEl.style.display = hasDiscount ? 'inline' : 'none';
        }
      }

      const saveEl = root.querySelector('[data-pf-save]');
      if (saveEl) {
        const diff = v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price - v.price : 0;
        saveEl.hidden = !diff;
        const amtEl = saveEl.querySelector('[data-pf-save-amount]');
        if (amtEl && diff) amtEl.textContent = formatMoney(diff);
      }

      // Hide the whole nudges row (and its border) when nothing inside it is visible
      const nudgesEl = root.querySelector('[data-pf-nudges]');
      if (nudgesEl) nudgesEl.hidden = ![...nudgesEl.children].some((c) => !c.hidden);

      // Hurry up bar: uses the real inventory of the selected size
      const lowEl = root.querySelector('[data-pf-lowstock]');
      if (lowEl) {
        const threshold = parseInt(lowEl.dataset.threshold, 10) || 0;
        const match = (lowEl.dataset.inv || '').split(',').find((pair) => pair.split(':')[0] === String(v.id));
        const qty = match ? parseInt(match.split(':')[1], 10) : 0;
        const show = threshold > 0 && !!available && qty > 0 && qty <= threshold;
        lowEl.hidden = !show;
        const qtyEl = lowEl.querySelector('[data-pf-lowstock-qty]');
        if (qtyEl) qtyEl.textContent = show ? qty : '';
        if (show) {
          const pct = Math.max(8, Math.min(100, Math.round((qty / threshold) * 100)));
          lowEl.style.setProperty('--pdp-hurry', pct + '%');
        }
      }

      if (v.featured_media && v.featured_media.id) goToMediaId(v.featured_media.id);
    };

    sizePills.forEach((pill) => {
      pill.addEventListener('click', (e) => {
        e.preventDefault();
        sizePills.forEach((p) => {
          p.classList.remove('is-active');
          p.setAttribute('aria-pressed', 'false');
        });
        pill.classList.add('is-active');
        pill.setAttribute('aria-pressed', 'true');

        // Show the selected size in the "At a glance" row and in the "Select Size" label
        root.querySelectorAll('[data-pf-glance-size], [data-pf-selected-size]').forEach((el) => {
          el.textContent = pill.dataset.value;
        });

        if (pill.dataset.variantId) syncVariant(pill.dataset.variantId);
      });
    });

    // ── Add to bag ──
    const handleAddToBag = async (btn) => {
      const variantId = variantIdInput?.value;
      if (!variantId || (btn && btn.disabled)) return;

      const textEl = btn?.querySelector('[data-pf-sticky-add-text], [data-pf-add-text]') || btn;
      const originalText = textEl ? textEl.textContent : 'Add to bag';
      if (btn) btn.disabled = true;
      if (textEl) textEl.textContent = 'Adding...';

      try {
        const sectionIds = [];
        document.querySelectorAll('cart-items-component').forEach((item) => {
          if (item.dataset.sectionId && !sectionIds.includes(item.dataset.sectionId)) sectionIds.push(item.dataset.sectionId);
        });

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);
        if (sectionIds.length > 0) {
          formData.append('sections', sectionIds.join(','));
          formData.append('sections_url', window.location.pathname);
        }

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        });
        if (!response.ok) throw new Error('Add to cart failed');
        const addData = await response.json();

        const cartResponse = await fetch('/cart.js');
        const cartData = await cartResponse.json();

        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cartData,
            sourceId: 'pf-product-template',
            data: { itemCount: cartData.item_count, sections: addData.sections }
          }
        }));

        const cartDrawer = document.getElementById('cart-drawer') || document.querySelector('cart-drawer, cart-drawer-component');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else if (cartDrawer && typeof cartDrawer.showDialog === 'function') {
          cartDrawer.showDialog();
        } else {
          const trigger = document.querySelector('[data-testid="cart-drawer-trigger"], [data-cart-drawer-trigger], .header__icon--cart, #cart-icon-bubble');
          if (trigger) trigger.click();
          else window.location.href = window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart` : '/cart';
        }

        if (textEl) textEl.textContent = 'Added';
        setTimeout(() => {
          if (textEl) textEl.textContent = originalText;
          if (btn) btn.disabled = false;
        }, 1200);
      } catch (err) {
        console.error('Add to cart error:', err);
        if (textEl) textEl.textContent = 'Try again';
        setTimeout(() => {
          if (textEl) textEl.textContent = originalText;
          if (btn) btn.disabled = false;
        }, 1200);
      }
    };

    [addToBagBtn, stickyAddBtn].forEach((btn) => {
      if (!btn) return;
      btn.addEventListener('click', (e) => { e.preventDefault(); handleAddToBag(btn); });
    });

    // ── Buy now (main button + card button) ──
    const handleBuyNow = async (btn) => {
      const variantId = variantIdInput?.value;
      if (!variantId || !btn || btn.disabled) return;

      const originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Please wait...';

      try {
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', Math.max(1, parseInt(qtyField?.value, 10) || 1));
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        });
        if (!response.ok) throw new Error('Could not add this item to the cart');
        window.location.assign(`${window.Shopify?.routes?.root || '/'}checkout`);
      } catch (err) {
        console.error('Buy Now error:', err);
        btn.disabled = false;
        btn.textContent = originalText;
        alert('We could not start checkout. Please try again.');
      }
    };

    [buyNowBtn, stickyBuyBtn].forEach((btn) => {
      if (!btn) return;
      btn.addEventListener('click', (e) => { e.preventDefault(); handleBuyNow(btn); });
    });

    // ── Share ──
    const shareBtn = root.querySelector('[data-share-btn]');
    if (shareBtn) {
      shareBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        const shareData = {
          title: document.title,
          text: 'Check out this fragrance from Balad Perfumes',
          url: window.location.href
        };
        if (navigator.share) {
          try { await navigator.share(shareData); } catch (err) {}
        } else if (navigator.clipboard) {
          try {
            await navigator.clipboard.writeText(window.location.href);
            const orig = shareBtn.innerHTML;
            shareBtn.innerHTML = '<span style="font-size:10px;font-weight:600;">Copied</span>';
            setTimeout(() => { shareBtn.innerHTML = orig; }, 2000);
          } catch (err) {}
        }
      });
    }

    // ── Detail card (desktop): if taller than the window, offset it so its end can be reached ──
    const pinned = [root.querySelector('.pdp-info')].filter(Boolean); // photos stay pinned by CSS only
    const readPx = (name) => parseFloat(getComputedStyle(document.documentElement).getPropertyValue(name)) || 0;
    const updatePinned = () => {
      pinned.forEach((el) => {
        if (!desktopQuery.matches) { el.style.removeProperty('top'); return; }
        const header = readPx('--header-group-height') || readPx('--header-height') || 66;
        el.style.top = Math.min(header + 12, window.innerHeight - el.offsetHeight - 24) + 'px';
      });
    };
    updatePinned();
    window.addEventListener('resize', updatePinned, { passive: true });
    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(updatePinned);
      pinned.forEach((el) => ro.observe(el));
    }

    // ── Sticky card: bottom-right card on desktop, slim bar on phones (only after the main buttons scroll out of view) ──
    if (stickyBar) {
      let ticking = false;
      let dismissed = false;
      let cardOn = false;
      let pastActions = false;

      const mobileQuery = window.matchMedia('(max-width: 749px)');
      const actionsEl = root.querySelector('.pdp-actions');

      // Find the floating WhatsApp button (the fixed-position element that holds a WhatsApp link)
      const findWhatsApp = () => {
        const found = new Set();
        document.querySelectorAll('a[href*="wa.me"], a[href*="whatsapp.com"], [class*="whatsapp" i], [id*="whatsapp" i], [aria-label*="whatsapp" i]').forEach((node) => {
          if (root.contains(node)) return;
          let el = node;
          while (el && el !== document.body && el !== document.documentElement) {
            if (getComputedStyle(el).position === 'fixed') { found.add(el); break; }
            el = el.parentElement;
          }
        });
        return [...found];
      };

      const liftWhatsApp = () => {
        const cardBottom = parseFloat(getComputedStyle(stickyBar).bottom) || 0;
        // The close button sticks out above the card, so clear it too, plus a small gap
        const closeOverhang = stickyClose ? Math.abs(parseFloat(getComputedStyle(stickyClose).top)) || 0 : 0;
        const lift = cardBottom + stickyBar.offsetHeight + closeOverhang + 14;
        findWhatsApp().forEach((el) => {
          if (el.dataset.pfOrigBottom === undefined) {
            el.dataset.pfOrigBottom = getComputedStyle(el).bottom;
            el.style.transition = 'bottom 0.35s cubic-bezier(0.16, 1, 0.3, 1), transform 0.25s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.25s ease';
          }
          el.style.bottom = cardOn ? lift + 'px' : el.dataset.pfOrigBottom;
        });
      };

      const update = () => {
        // Desktop: always on (unless closed). Phones: only once the main Add to bag / Buy now row has scrolled above the screen.
        cardOn = !dismissed && (!mobileQuery.matches || pastActions);
        if (cardOn) stickyBar.setAttribute('data-visible', 'true');
        else stickyBar.removeAttribute('data-visible');
        stickyBar.setAttribute('aria-hidden', cardOn ? 'false' : 'true');
        liftWhatsApp();
        ticking = false;
      };

      if (actionsEl && 'IntersectionObserver' in window) {
        new IntersectionObserver(([entry]) => {
          pastActions = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          update();
        }).observe(actionsEl);
      }

      if (stickyClose) {
        stickyClose.addEventListener('click', () => {
          dismissed = true;
          update();
        });
      }

      window.addEventListener('resize', update, { passive: true });
      if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', update);
      if ('ResizeObserver' in window) new ResizeObserver(liftWhatsApp).observe(stickyBar);

      // The WhatsApp widget may be injected a moment after load, so keep looking for a few seconds
      let tries = 0;
      const retry = () => { liftWhatsApp(); if (++tries < 20) window.setTimeout(retry, 500); };
      update();
      retry();
    }

    // ── Preselect size from ?size= ──
    const targetSize = new URLSearchParams(window.location.search).get('size');
    if (targetSize && sizePills.length) {
      const match = sizePills.find((p) => (p.dataset.value || p.textContent || '').trim().toLowerCase() === targetSize.trim().toLowerCase());
      if (match) match.click();
    }

    // ── Rating line: scroll to the Judge.me widget when it exists on the page ──
    root.querySelectorAll('[data-pf-reviews-scroll]').forEach((el) => {
      el.addEventListener('click', (e) => {
        const widget = document.querySelector('#judgeme_product_reviews');
        if (!widget) return;
        e.preventDefault();
        widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    // ── Write a review → opens Judge.me form ──
    const initJudgeMe = () => {
      if (window.jdgm && typeof window.jdgm.initializeWidgets === 'function') window.jdgm.initializeWidgets();
    };

    root.querySelectorAll('[data-pf-reviews-open]').forEach((btn) => {
      btn.addEventListener('click', () => {
        let attempts = 0;
        const open = () => {
          const widget = document.querySelector('#judgeme_product_reviews');
          const writeBtn = widget?.querySelector('.jdgm-write-rev-link, .jdgm-rev-widg__write-rev-btn, .jdgm-write-rev-btn')
            || [...(widget?.querySelectorAll('button, a, [role="button"]') || [])].find((b) =>
              /write\s+a?\s*review/i.test(`${b.textContent} ${b.getAttribute('aria-label') || ''}`));
          if (writeBtn) { writeBtn.click(); return; }
          if (attempts < 60) {
            attempts += 1;
            if (attempts % 4 === 0) initJudgeMe();
            window.setTimeout(open, 250);
          }
        };
        initJudgeMe();
        open();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist-drawer"]) return;
  try {
    
(function() {
  const drawer   = document.getElementById('wishlist-drawer');
  const backdrop = document.getElementById('wishlist-drawer-backdrop');
  const closeBtn = document.getElementById('wishlist-drawer-close');
  const grid     = document.getElementById('wishlist-drawer-grid');
  const empty    = document.getElementById('wishlist-drawer-empty');
  const footer   = document.getElementById('wishlist-drawer-footer');
  const countEl  = document.getElementById('wishlist-drawer-count');
  const clearBtn = document.getElementById('wishlist-drawer-clear-btn');
  const toast    = document.getElementById('wishlist-drawer-toast');
  const continueBtn = document.getElementById('wishlist-continue-shop-btn');

  if (!drawer) return;

  let toastTimer = null;
  function showToast(msg, duration = 2200) {
    if (!toast) return;
    toast.textContent = msg;
    toast.style.display = 'block';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => {
      toast.style.display = 'none';
    }, duration);
  }

  function openDrawer() {
    drawer.setAttribute('open', '');
    if (backdrop) backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    renderGrid();
  }

  function closeDrawer() {
    drawer.removeAttribute('open');
    if (backdrop) backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  // Close handlers
  if (backdrop) backdrop.addEventListener('click', closeDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (continueBtn) continueBtn.addEventListener('click', closeDrawer);
  drawer.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });

  // Clear all button handler in footer
  if (clearBtn) {
    clearBtn.addEventListener('click', () => {
      if (confirm('Clear all items from wishlist?')) {
        if (typeof window.clearWishlist === 'function') {
          window.clearWishlist();
        } else {
          localStorage.setItem('wishlist', '[]');
          document.dispatchEvent(new CustomEvent('wishlist:update'));
        }
        showToast('Wishlist cleared');
      }
    });
  }

  // Add to Bag handler inside drawer
  grid.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-wl-add-cart]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const variantId = btn.dataset.wlAddCart;
    if (!variantId) return;

    btn.classList.add('is-loading');
    const originalText = btn.textContent;
    btn.textContent = 'Adding...';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 })
      });

      if (response.ok) {
        const item = await response.json();
        showToast(`Added to Bag`);
        
        // Dispatch cart updates
        document.dispatchEvent(new CustomEvent('cart:update', { detail: { resource: item } }));
        window.dispatchEvent(new CustomEvent('cart:update', { detail: { resource: item } }));
        
        // Trigger cart drawer if available
        const cartDrawerTrigger = document.querySelector('[data-testid="cart-drawer-trigger"], [data-open-cart-drawer], .balad-header__cart-button');
        if (cartDrawerTrigger) {
          setTimeout(() => {
            closeDrawer();
            cartDrawerTrigger.click();
          }, 500);
        }
      } else {
        const err = await response.json();
        showToast(err.description || 'Could not add item');
      }
    } catch (error) {
      showToast('Error adding to bag.');
    } finally {
      btn.classList.remove('is-loading');
      btn.textContent = originalText;
    }
  });

  // Remove handler with smooth slide-out animation
  grid.addEventListener('click', (e) => {
    const removeBtn = e.target.closest('[data-wishlist-remove]');
    if (!removeBtn) return;

    e.preventDefault();
    e.stopPropagation();

    const handle = removeBtn.dataset.wishlistRemove;
    const itemEl = removeBtn.closest('.wl-item');

    if (itemEl) {
      itemEl.classList.add('is-removing');
      setTimeout(() => {
        if (typeof window.removeFromWishlist === 'function') {
          window.removeFromWishlist(handle);
        } else {
          let list = JSON.parse(localStorage.getItem('wishlist') || '[]');
          list = list.filter(i => i.handle !== handle);
          localStorage.setItem('wishlist', JSON.stringify(list));
          document.dispatchEvent(new CustomEvent('wishlist:update'));
        }
      }, 180);
    }
  });

  function renderGrid() {
    const list = JSON.parse(localStorage.getItem('wishlist') || '[]');
    const count = list.length;

    if (countEl) countEl.textContent = `(${count})`;

    if (count === 0) {
      grid.innerHTML = '';
      grid.style.display   = 'none';
      empty.style.display  = 'flex';
      footer.style.display = 'none';
      return;
    }

    grid.style.display   = 'flex';
    empty.style.display  = 'none';
    footer.style.display = 'flex';

    grid.innerHTML = list.map(item => {
      const t  = (item.title || '').replace(/</g,'&lt;').replace(/>/g,'&gt;');
      const img = item.image || '';
      const sizeParam = item.size && item.size !== 'Default' ? '?size=' + encodeURIComponent(item.size) : '';
      const productUrl = '/products/' + item.handle + sizeParam;
      const variantId = item.variantId || '';

      return `
        <article class="wl-item" data-handle="${item.handle}">
          <a class="wl-item__media" href="${productUrl}">
            ${img ? `<img class="wl-item__img" src="${img}" alt="${t}" loading="lazy">` : `<div class="wl-item__img-placeholder"></div>`}
          </a>

          <div class="wl-item__details">
            <div class="wl-item__row-top">
              <a class="wl-item__title" href="${productUrl}">${t}</a>
              <button
                class="wl-item__remove"
                type="button"
                aria-label="Remove item"
                title="Remove"
                data-wishlist-remove="${item.handle}"
              >
                <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </div>

            ${item.size && item.size !== 'Default' ? `<div class="wl-item__meta">Size: ${item.size}</div>` : ''}

            <div class="wl-item__price">${item.price || ''}</div>

            <div class="wl-item__actions">
              ${variantId ? `
                <button
                  type="button"
                  class="wl-item__add-btn"
                  data-wl-add-cart="${variantId}"
                  data-product-handle="${item.handle}"
                  data-product-title="${t}"
                >
                  Add to Bag
                </button>
              ` : `
                <a
                  href="${productUrl}"
                  class="wl-item__view-link"
                >
                  View Product
                </a>
              `}
            </div>
          </div>
        </article>`;
    }).join('');
  }

  // Re-render when wishlist changes
  document.addEventListener('wishlist:update', renderGrid);

  // Listen for the open trigger (header button dispatches this)
  document.addEventListener('wishlist-drawer:open', openDrawer);
  document.addEventListener('wishlist-drawer:close', closeDrawer);

  // Expose globally so the header button or scripts can call it
  window.openWishlistDrawer = openDrawer;
  window.closeWishlistDrawer = closeDrawer;
})();

  } catch(e) { console.error(e); }
})();
})();
